// extracted by mini-css-extract-plugin
export var chevronIcon = "_dd-2";
export var teamName = "_dd-1";
export var teamSwitcherButton = "_dd-0";